import {
	Component,
	OnInit,
	EventEmitter,
	Input,
	Output,
	ViewChild,
	ChangeDetectorRef,
	AfterViewInit,
} from "@angular/core";
import { ProjectDataProducto } from "src/app/entities/project-data-producto.entity";
import { ProjectData } from "src/app/entities/project-data.entity";
import { ColorComponent } from "src/app/color/color.component";
import { ModelService } from "src/app/services/model.service";
import { DB } from "src/app/datas/db";
import { ColorDataType } from "src/app/color/color-data.types";
import { HttpClient } from "@angular/common/http";
import { LoggerService } from "../../../services/logger.service";

@Component({
	selector: "app-product-picker",
	templateUrl: "./product-picker.component.html",
	styleUrls: ["./product-picker.component.scss"],
})
export class ProductPickerComponent implements OnInit, AfterViewInit {
	@Input() projectId: string;
	@Input() data: ProjectDataProducto;
	@Input() projectData: ProjectData;
	@Input() isDisabled: boolean = false;

	@Output() onModeloSeleccionado: EventEmitter<object> = new EventEmitter();
	@Output() onChangeFamily: EventEmitter<string> = new EventEmitter();
	@Output() onSavePerimeter: EventEmitter<string> = new EventEmitter();
	@Output() onAlturaSeleccionada: EventEmitter<any> = new EventEmitter();
	@Output() onPosteSeleccionado: EventEmitter<any> = new EventEmitter();
	@Output() onTopEdgeCutSelected: EventEmitter<any> = new EventEmitter();

	// Paleta de colores.
	@ViewChild("coloresRivisa") coloresRivisa: ColorComponent;

	public isCollapsed = false;

	public listadoTiposPanel: any[] = [];
	public listadoPaneles: any[] = [];
	public listadoBayonetas: any[] = [];

	public idTipoPanel: string;
	public idPanel: string;
	private anchuraPoste: string;

	// Indica si puede tener doble bayoneta.
	public canDouble: boolean = false;

	public tiposBayoneta: any = { no: "no", simple: "simple", doble: "doble" };

	public db = new DB();
	public arrayPostes: any[] = [];
	public posteSelecionado: any;

	// ESPRRIVISA-150 : Contents for Top Edge Cut dropdown (only available for ULTRA)
	public TopEdgeCutValuesAndText = [
		{ value: 0, text: "product_picker_topEdgeCut_beveled" },
		{ value: 1, text: "product_picker_topEdgeCut_straight" },
		{ value: 2, text: "product_picker_topEdgeCut_doubleEdgeHorizontal" },
	];

	constructor(
		public modelService: ModelService,
		//private catalogService: CatalogService,
		private cref: ChangeDetectorRef,
		private http: HttpClient
	) {}

	public ngOnInit() {
		this.familiaCercadoTitulo =
			this.db.cercadoTitulo[
				this.modelService.getLanguage().currentLanguage
			];
		this.familiaVerjaTitulo =
			this.db.verjaTitulo[
				this.modelService.getLanguage().currentLanguage
			];
		//ESPRIVISA-74 Se inicializa el componente y se mantiene cuando se viene del 3D (se destruye este componente) y mantiene el poste que habíamos seleccionado

		this.TipoPoste();
	}

	public ngAfterViewInit(): void {
		this.coloresRivisa.clickColor.subscribe(
			(res: { hex: string; _id: string }) => {
				if (res) {
					this.setColor(res); // this.data.hex Color = res.hex;	this.data.idColor = res._id;

					// ESPRRIVISA-150: Update Verja Information when color changes
					let iTopEdgeCut = undefined;
					let bIsUltraFence = this.verjaNombre == "ULTRA";

					if (bIsUltraFence) {
						let bCond1 = this.data.topEdgeCut !== undefined;
						let bCond2 = this.data.topEdgeCut !== null;
						if (bCond1 && bCond2) {
							iTopEdgeCut = this.data.topEdgeCut;
						} else {
							iTopEdgeCut = 0; // Default value in case of missing value (BEVELVED (en) -> BISELADO (es))
						}
					}

					if (bIsUltraFence) {
						this.updateConfigVerjaWithTopEdgeCut(true, iTopEdgeCut);
					} else {
						this.updateConfigVerja(true);
					}
				}
			}
		);
	}

	public initialize(currentProduct: ProjectDataProducto) {
		// Si viene un producto se carga, sino deja el que tenga (si hay).
		if (currentProduct) this.data = currentProduct;

		this.listadoTiposPanel = []; // Tipos de panel de un modelo.
		this.listadoPaneles = []; // Variantes del panel del modelo.

		this.idPanel = "";
		this.idTipoPanel = "";
		this.cercadoNombre = "";
		this.verjaNombre = "";

		// En caso de no existir y no venir uno nuevo -> salir.
		if (this.data && !this.data.familia) return;

		let update = false;

		if (this.data.familia.tipo === DB.CERCADO) {
			//this.listadoModelos = this.db.cercados; // Modelos de Cercados.
			if (this.data.modelo) {
				this.listadoTiposPanel = this.db.tiposCercados.filter((x) => {
					return x.modelo == this.data.modelo._id;
				});
				this.listadoPaneles = this.db.panels.filter((x) => {
					return x.tipoPanel == this.data.tipoPanel._id;
				});
				update = true;
			}
		} else {
			//this.listadoModelos = this.db.verjas; // Modelos de Verjas.
			if (this.data.modelo) {
				this.listadoTiposPanel = this.db.tiposVerjas.filter((x) => {
					return x.modelo == this.data.modelo._id;
				});
				this.listadoPaneles = this.db.panels.filter((x) => {
					return x.tipoPanel == this.data.tipoPanel._id;
				});
				update = true;
			}
		}

		if (update) {
			this.anchuraPoste = this.data.anchuraPoste;
			//	this.recuperaColorYBallonetas(true); this.cref.markForCheck();

			// Actualiza si hay selección.
			if (this.data.modelo) {
				if (this.data.modelo.IDFamilia == DB.CERCADO) {
					this.cercadoNombre = this.data.modelo.idUnity;
					this.verjaNombre = "";
				} else if (this.data.modelo.IDFamilia == DB.VERJA) {
					this.cercadoNombre = "";
					this.verjaNombre = this.data.modelo.idUnity;
					this.canDouble =
						this.data.modelo.idUnity &&
						!this.data.modelo.idUnity.startsWith("RITMO");
					this.actualizarColorSegunModelo();
				}
			}

			if (this.data.tipoPanel) {
				this.idTipoPanel = this.data.tipoPanel._id;
			}
			if (this.data.panel) {
				this.idPanel = this.data.panel._id;
			}

			this.recuperaColorYBallonetas(true);
			this.cref.markForCheck();
		}
	}

	// UI muestra u oculta el configurador del modelo de la familia Verja.
	public UIisVERJA(): boolean {
		return (
			this.data &&
			this.data.modelo &&
			this.data.modelo.IDFamilia === DB.VERJA
		);
	}

	// UI muestra u oculta el configurador del modelo de la familia Cercado.
	public UIisCERCADO(): boolean {
		return (
			this.data &&
			this.data.modelo &&
			this.data.modelo.IDFamilia === DB.CERCADO
		);
	}

	public textSelectMeshCercado() {
		return this.modelService.getString("builder_mesh_select");
	}

	public textSelectMeshVerja() {
		return this.modelService.getString("builder_grill_select");
	}

	/**
	 * Recoge los modelos de servidor en base a una familia
	 * @param objFamilia - Objeto JSON con los datos de la familia seleccionada
	 */
	public recuperaModelos(objFamilia: any): void {
		this.data.familia = objFamilia;

		//this.listadoModelos = (objFamilia.tipo === DB.CERCADO) ? this.db.cercados: this.db.verjas;
		this.listadoTiposPanel = [];
		this.listadoPaneles = [];
		this.listadoBayonetas = [];
		this.idTipoPanel = undefined;
		this.idPanel = undefined;
		this.data.modelo = null;
		this.data.tipoPanel = null;
		this.data.panel = null;
		this.data.bayoneta = null;
		this.data.anchuraPoste = undefined;
		this.data.idBayoneta = undefined;
		this.data.tipoBayoneta = this.tiposBayoneta.no;

		if (this.data.modelo) {
			this.onChangeFamily.emit(this.data.modelo.IDFamilia);
		} else {
			console.warn("----- this.data.familia.idUnity -> NO EXISTE");
		}
	}

	public ShowDimensions(): boolean {
		if (this.data && this.data.modelo && this.data.modelo.idUnity) {
			if (this.data.modelo.idUnity == DB.VERJA_BRICO_FAX) return false;
			if (this.data.modelo.idUnity == DB.VERJA_FAX_DH) return false;
			return this.data.modelo.idUnity != DB.VERJA_MAXI_FAX;
		}
		return false;
	}

	public ShowComboTipo(): boolean {
		if (this.data && this.data.modelo && this.data.modelo.idUnity) {
			return this.data.modelo.idUnity == DB.VERJA_FAX_DH;
		}
		return false;
	}
	// ESPRIVISA-74
	public TipoPoste(): void {
		if (this.data.tipoPanel) {
			// Recogemos el error, debido a que las Verjas, no tienen tipoPoste en el tipoPanel.
			try {
				if (this.data.tipoPanel.poste.length == 1) {
					this.data.tipoPoste = this.data.tipoPanel.poste[0];
				}
			} catch (e) {
				console.log("Project Tipo Verja no tiene tipoPoste");
			}

			//Se da para dar soporte a los proyectos antiugos donde el poste antes era un string y ahora un array
			if (this.data.tipoPanel.poste instanceof Array) {
				this.arrayPostes = this.data.tipoPanel.poste.filter(
					(poste) => poste != this.data.tipoPoste
				);
				if (this.data.tipoPanel.poste.length == 1) {
					this.data.tipoPoste = this.data.tipoPanel.poste[0];
				} else if (this.data.tipoPanel.poste == undefined) {
					this.data.tipoPoste = this.data.panel.posteExtremo;
				}
			} else {
				//Nos indica en el HTML el poste seleccionado en proyectos antiguos que antes era un String el this.data.tipoPanel.poste
				// Cuando se cargen los proyectos antiguos que antes eran un String aparecerá el poste seleccionado en ese momento.
				this.arrayPostes.push(this.data.tipoPanel.poste);
				this.data.tipoPoste = this.data.tipoPanel.poste;
			}
			//this.arrayPostes = this.data.tipoPanel.poste;
		}
	}
	// public posteCache():any{
	// 	this.data.tipoPanel.poste = localStorage.getItem('poste');
	// 	return this.data.tipoPanel.poste;
	// }

	//
	/*
	ngDoCheck(){

		console.log("---> ngDoCheck");

		this.arrayPostes = [];
		this.TipoPoste();
	}
	*/

	public recogerPoste($event) {
		this.posteSelecionado = $event.target.value;
		this.data.tipoPoste = this.posteSelecionado;
		this.onPosteSeleccionado.emit(this.posteSelecionado);

		this.TipoPoste();

		return this.posteSelecionado;
	}
	//cuando solo hay un poste en el array
	public valorPoste() {
		this.data.tipoPoste = this.arrayPostes[0];
		this.onPosteSeleccionado.emit(this.arrayPostes[0]);
		return this.arrayPostes.length == 0
			? (this.arrayPostes[0] = "")
			: this.arrayPostes[0];
	}

	// ## ESPRIVISA-74

	// ESPRRIVISA-150: Select and Update methods for top edge cut value
	public getTopEdgeCut($event: any) {
		this.data.topEdgeCut = parseInt($event.target.value);
		this.onTopEdgeCutSelected.emit(this.data.topEdgeCut);

		LoggerService.showDebug("topEdgeCut", this.data.topEdgeCut);
		this.updateConfigVerjaWithTopEdgeCut(false, this.data.topEdgeCut);

		return this.data.topEdgeCut;
	}

	public seleccionaTopEdgeCut() {
		let todEdgeCutValue =
			this.data?.topEdgeCut !== undefined ? this.data?.topEdgeCut : 0;
		this.onTopEdgeCutSelected.emit(todEdgeCutValue);
		this.updateConfigVerjaWithTopEdgeCut(false, this.data.topEdgeCut);

		return todEdgeCutValue;
	}

	public Dimensiones(): string {
		return this.data.tipoPanel ? this.data.tipoPanel.dimensiones : "";
	}

	/**
	 * Recupera los Tipos de Panel asociados a un modelo seleccionado.
	 * En este punto también se realiza la llamada para recuperar las puertas
	 * asociadas al modelo seleccionado
	 * @param objModelo - Objeto JSON con los datos del modelo seleccionado
	 */
	public recuperaTiposPanel(objModelo: any): boolean {
		if (!objModelo) return false;

		localStorage.setItem("panel", JSON.stringify(objModelo));
		this.data.modelo = objModelo;
		// Llamada para los paneles de este modelo
		//this.catalo gService.getTiposPanel(objModelo._id).subscribe((rs) => {
		this.listadoTiposPanel = [];
		this.listadoPaneles = [];
		this.listadoBayonetas = [];

		this.idTipoPanel = undefined;
		this.idPanel = undefined;
		this.data.tipoPanel = null;
		this.data.panel = null;
		this.data.bayoneta = null;
		this.data.anchuraPoste = undefined;
		this.data.idBayoneta = undefined;
		this.data.tipoBayoneta = this.tiposBayoneta.no;

		if (this.data.familia.tipo == DB.CERCADO) {
			this.listadoTiposPanel = this.db.tiposCercados.filter((x) => {
				return x.modelo == objModelo._id;
			});
		} else {
			this.listadoTiposPanel = this.db.tiposVerjas.filter((x) => {
				return x.modelo == objModelo._id;
			});
		}
		this.listadoTiposPanel.sort((a, b) => a.order - b.order);

		if (this.data.modelo && this.data.modelo.idUnity) {
			this.canDouble = !this.data.modelo.idUnity.startsWith("RITMO");
		} else {
			this.canDouble = false;
		}

		// Se seleccionan los modelos de puerta asociados a este modelo
		this.onModeloSeleccionado.emit(objModelo);

		let bIsUltraFence = objModelo.idUnity == "ULTRA";

		if (bIsUltraFence) {
			this.onTopEdgeCutSelected.emit(this.data.topEdgeCut);
		} else {
			this.data.topEdgeCut = undefined;
		}

		this.actualizarColorSegunModelo();

		return true;
	}

	public configCorrect(): boolean {
		return (
			this.data !== undefined &&
			this.data.panel !== undefined &&
			this.data.tipoPanel !== undefined
		);
	}

	// Preparar la paleta de colores si es la familia VERJA.
	private actualizarColorSegunModelo() {
		if (!this.data.modelo || this.data.modelo.IDFamilia === DB.CERCADO)
			return;

		// Para todas las verjas el Antracita no está contemplado.
		this.coloresRivisa.activoColor(ColorDataType.antracita, true);

		if (
			this.data.modelo.idUnity === "ULTRA" ||
			this.data.modelo.idUnity === "DECOR"
		) {
			this.coloresRivisa.activoColor(ColorDataType.blanco, true);
		} else if (this.data.modelo.idUnity === "NOVE") {
			// SOLO el VERDE, RAL y ¿OXIDON?
			this.coloresRivisa.activoColor(ColorDataType.galvanizado, false);
			this.coloresRivisa.activoColor(ColorDataType.blanco, false);
			// Corregir color actual.

			//#ESPRIVISA-28 poner por defecto el verde y solucionar problema con Antracita que se reseteaba a blanco.
			if (
				!this.data.idColor ||
				this.data.idColor ===
					this.coloresRivisa.colors[ColorDataType.galvanizado]._id ||
				this.data.idColor ===
					this.coloresRivisa.colors[ColorDataType.blanco]._id
			) {
				// En caso de tener ANTRACITA, GALVANIZADO o BLANCO pasar a VERDE.
				this.setColor(this.coloresRivisa.colors[ColorDataType.verde]);
			}
		} else {
			// TODOS menos el GALVANIZADO.
			// Resto de verjas ocultar GALVANIZADO.
			this.coloresRivisa.activoColor(ColorDataType.galvanizado, false);
			this.coloresRivisa.activoColor(ColorDataType.blanco, true);
			// Corregir color actual.
			if (
				!this.data.idColor ||
				this.data.idColor ===
					this.coloresRivisa.colors[ColorDataType.galvanizado]._id
			) {
				// En caso de tener Galvanizado , se setea a Verde por defecto
				this.setColor(this.coloresRivisa.colors[ColorDataType.verde]);
			}
		}
	}

	/**
	 * Recupera los Tipos de Panel asociados a un modelo seleccionado.
	 * En este punto de la configuración también se realiza la llamada para
	 * recuperar las puertas asociadas al modelo seleccionado
	 *
	 * @param objTipoPanel - Objeto JSON con los datos del modelo seleccionado
	 */
	public recuperaPaneles(): void {
		//quitamos el tipoPoste seleccionado y se reinicia cuando se elig una nueva altura.
		this.data.tipoPoste = "";
		if (this.data.familia.tipo === DB.CERCADO) {
			this.data.tipoPanel = this.db.tiposCercados.find((v) => {
				return v._id == this.idTipoPanel;
			});
		} else {
			this.data.tipoPanel = this.db.tiposVerjas.find((v) => {
				return v._id == this.idTipoPanel;
			});
		}
		this.listadoPaneles = this.db.panels.filter((x) => {
			return x.tipoPanel == this.data.tipoPanel._id;
		});
		const objetoPanels = this.db.panels.find((x) => {
			return x.tipoPanel == this.data.tipoPanel._id;
		});
		this.onAlturaSeleccionada.emit(objetoPanels.alturaValor);

		this.listadoBayonetas = [];
		this.idPanel = undefined;
		this.data.panel = undefined;
		this.data.bayoneta = null;
		this.data.anchuraPoste = undefined;
		this.data.idBayoneta = undefined;
		this.data.tipoBayoneta = this.tiposBayoneta.no;

		// ESPRRIVISA-150: Obtain selected TopEdgeCut  value (only for ULTRA fences)
		let iTopEdgeCut = undefined;
		let bIsUltraFence = this.verjaNombre == "ULTRA";

		if (bIsUltraFence) {
			let bCond1 = this.data.topEdgeCut !== undefined;
			let bCond2 = this.data.topEdgeCut !== null;
			if (bCond1 && bCond2) {
				iTopEdgeCut = this.data.topEdgeCut;
			} else {
				iTopEdgeCut = 0; // Default value in case of missing value (BEVELVED, BISELADO)
				this.data.topEdgeCut = 0;
				this.onTopEdgeCutSelected.emit(this.data.topEdgeCut);
			}
		} else {
			this.data.topEdgeCut = undefined;
		}

		// ESPRRIVISA-150: Use TopEdgeCut value to filter panels too (only for ULTRA fences)
		if (this.data.familia.tipo == DB.VERJA) {
			if (bIsUltraFence) {
				this.updateConfigVerjaWithTopEdgeCut(false, iTopEdgeCut);
			} else {
				this.updateConfigVerja(false);
			}
		} else {
			this.setColor(
				this.db.paleta.find((c) => {
					return c._id == this.listadoPaneles[0].color[0];
				})
			);
		}
		LoggerService.showDebug("objetoPanels", objetoPanels);

		// ESPRIVISA-74 LLAMAMOS a tipo poste cuando se modifica la altura del poste
		//recoga el valor del poste si solo tiene 1 poste y si tiene 2 que aparezca el select desplegable
		this.TipoPoste();
	}

	// // ESPRRIVISA-150: Actualiza el panel según el color y corte superior (sólo para ULTRA).
	private updateConfigVerjaWithTopEdgeCut(initPhase, iTopEdgeCut) {
		if (!this.idTipoPanel && !this.idTipoPanel) return;
		this.data.panel = this.listadoPaneles.find((p) => {
			return (
				p.color.includes(this.data.idColor) &&
				p.topEdgeCut === iTopEdgeCut
			);
		}); // FIXME
		this.idPanel = this.data.panel._id;
		this.recuperaColorYBallonetas(initPhase);

		LoggerService.showDebug(this.data.panel);
	}

	// Actualiza el panel según el color.
	private updateConfigVerja(initPhase) {
		if (!this.idTipoPanel && !this.idTipoPanel) return;
		this.data.panel = this.listadoPaneles.find((p) => {
			return p.color.includes(this.data.idColor);
		}); // FIXME
		this.idPanel = this.data.panel._id;
		this.recuperaColorYBallonetas(initPhase);

		LoggerService.showDebug(this.data.panel);
	}

	// Recupera los colores disponibles asociados a un Tipo Panel seleccionado.
	private recuperaColorYBallonetas(initPhase): void {
		if (this.data.panel) {
			if (this.UIisCERCADO()) {
				this.data.idColor = this.data.panel.color[0];
				const c = this.db.paleta.filter((p) => {
					return p._id === this.data.idColor;
				});
				this.data.hexColor = c[0].hex;

				this.listadoBayonetas = this.db.bayonetas.filter((b) => {
					return (
						b.color.includes(this.data.idColor) &&
						b.paneles.includes(this.idPanel)
					);
				});
				//this.catalogService.getBayonetas(this.idPanel, this.data.idColor).subscribe((rsBayos) => {
				//this.listadoBayonetas = [];
				if (!initPhase) this.data.tipoBayoneta = this.tiposBayoneta.no;
				//rsBayos.result.forEach((element: any) => { this.listadoBayonetas.push(element); });
				this.cref.markForCheck();
				//});
			} else {
				if (!initPhase) this.data.tipoBayoneta = this.tiposBayoneta.no;
				this.listadoBayonetas = [];
				if (this.data && this.data.panel.bayoneta) {
					//this.listadoBayonetas = this.db.bayonetas.find(b => { return b._id == this.data.panel.bayoneta.id });
					this.data.bayoneta = this.db.bayonetas.find((b) => {
						return b._id == this.data.panel.bayoneta.id;
					});
					this.listadoBayonetas.push(this.data.bayoneta);
					//this.catalogService.getBayonetasById(this.data.panel.bayoneta.id).subscribe((res) => {
					//this.listadoBayonetas.push(res);
					//this.data.bayoneta = this.listadoBayonetas[0];
					this.cref.markForCheck();
					//});
				}
			}
		}
	}

	/**
	 * Selecciona el panel en base a la elección del usuario
	 * @param objPanel - Objecto JSON con los datos del modelo seleccionad.
	 *                   En caso de no llegar este object, selecciona el valor almacenado en data
	 */
	public seleccionaPanel(initPhase?: boolean): void {
		this.data.panel = this.db.panels.find((x) => {
			return x._id == this.idPanel;
		});
		//this.data.panel = this.catalog Service.getLocalFromTypeById('get Paneles', this.idPanel);
		this.recuperaColorYBallonetas(initPhase);
		this.data.tipoPoste = this.data.panel.posteExtremo;
	}

	/** incluye en los datos de proyecto la medida de poste actual */
	public seleccionaAnchuraPoste(): void {
		setTimeout(() => {
			this.data.anchuraPoste = this.anchuraPoste;
		}, 0);
	}

	/** recupera la bayoneta adecuada para el color, panel y medida de poste actual */
	public seleccionaBayoneta() {
		if (this.data.tipoBayoneta !== this.tiposBayoneta.no) {
			this.data.bayoneta = this.listadoBayonetas.find((bayoneta) => {
				return bayoneta.anchuraPoste === this.data.anchuraPoste;
			});
		} else {
			this.data.bayoneta = null;
		}
	}

	public seleccionaBayonetaVerja() {
		if (this.data.tipoBayoneta !== this.tiposBayoneta.no) {
			if (this.data.bayoneta !== null) return;

			let idBayoneta;
			if (this.data.tipoBayoneta === this.tiposBayoneta.simple) {
				if (this.data.bayoneta._id === this.data.panel.bayoneta.id)
					return;
				idBayoneta = this.data.panel.bayoneta.id;
				this.data.bayoneta = this.db.bayonetas.find((b) => {
					return this.data.panel.bayoneta.id;
				});
				this.listadoBayonetas.push(this.data.bayoneta);
				this.cref.markForCheck();
			} else {
				// Doble
				idBayoneta = this.data.panel.bayonetaDoble.id;
				this.data.bayoneta = this.db.bayonetas.find((b) => {
					return this.data.panel.bayonetaDoble.id;
				});
				this.listadoBayonetas.push(this.data.bayoneta);
				this.cref.markForCheck();
			}
			this.data.bayoneta = this.db.bayonetas.find((b) => {
				return b._id === idBayoneta;
			});
			this.listadoBayonetas.push(this.data.bayoneta);
			this.cref.markForCheck();
		} else {
			this.data.bayoneta = null;
		}
	}

	// Actualiza el actual color del perímetro.
	public setColor(color: any) {
		this.data.idColor = color._id;
		this.data.hexColor = color.hex;
	}

	// Descargar el PD del modelo.
	public downloadModelPDF() {
		if (this.data.modelo) {
			this.http
				.get("/assets/pdf/" + this.data.modelo.idUnity + ".pdf", {
					responseType: "blob",
				})
				.subscribe((data) => {
					const blob = new Blob([data], { type: "application/pdf" });
					const url = window.URL.createObjectURL(blob);
					window.open(url);
				});
		}
	}

	// Para altura 2m00 y modelo LUX_EST, podemos elegir anchura del poste
	public posteSeleccionable(): boolean {
		if (!this.data.panel || !this.data.modelo) return false;
		if (this.data.panel.altura !== "2m00") return false;
		if (this.data.modelo.idUnity !== "LUX_EST") return false;
		if (!this.data.anchuraPoste || this.data.anchuraPoste === "")
			this.data.anchuraPoste = "LUX50";
		this.data.tipoPoste = this.data.anchuraPoste;
		return true;
	}

	/////////////////////////////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////////////////
	///////////////////////// Ventanas de productos ///////////////////////// INIT
	// Solo una ventana puede estar abierta o todas cerradas.
	public classVerjas: String = "ocultar";
	public classCercados: String = "ocultar";
	public cercadoNombre: String = "";
	public verjaNombre: String = "";
	public familiaVerjaTitulo: string = "";
	public familiaCercadoTitulo: string = "";
	// Actual ventana abierta de productos:
	// 0 : Las dos están cerradas.
	// 1 : Cercados está abierta.
	// 2 : Verjas está abierta.
	public displayProducto = 0; // Almacenar el panel actual abierto.
	public panelProductos(vent: number) {
		this.displayProducto = this.displayProducto == vent ? 0 : vent;
		this.classCercados = this.displayProducto == 1 ? "mostrar" : "ocultar";
		this.classVerjas = this.displayProducto == 2 ? "mostrar" : "ocultar";
	}

	// Click sobre un modelo de verja.
	public selectVerja(verja: String) {
		this.data.tipoPoste = "";
		if (this.projectData.estado !== 0) return;

		this.data.familia = this.db.familiaVERJA;

		if (this.verjaNombre != verja) {
			this.data.tipoPanel = this.db.verjas.find((x) => {
				return x.idUnity == verja;
			});
			this.recuperaTiposPanel(this.data.tipoPanel);
			// Corregir color según panel.
			this.setColor(this.coloresRivisa.colors[ColorDataType.verde]);

			this.cercadoNombre = "";
			this.verjaNombre = verja;
		}

		this.arrayPostes = [];
	}

	// Click sobre un modelo de cercado.
	public selectCercado(cercado: String) {
		if (this.projectData.estado !== 0) return;

		this.data.familia = this.db.familiaCERCADO;

		if (this.cercadoNombre != cercado) {
			this.data.tipoPanel = this.db.cercados.find((x) => {
				return x.idUnity == cercado;
			});
			this.recuperaTiposPanel(this.data.tipoPanel);
			// Corregir el color según panel.
			let index =
				cercado == DB.CERCADO_ANUDADA
					? ColorDataType.galvanizado
					: ColorDataType.verde;
			this.setColor(this.coloresRivisa.colors[index]);

			this.cercadoNombre = cercado;
			this.verjaNombre = "";
		}
	}

	public actualModelo(id: string) {
		return this.data && this.data.modelo && this.data.modelo.idUnity === id
			? "fotoActive"
			: "foto";
	}
	///////////////////////// Ventanas de productos ///////////////////////// END

	public getModelo() {
		return this.data && this.data.modelo;
	}
}
function poste(poste: any): any {
	throw new Error("Function not implemented.");
}
